import { useState, useEffect } from 'react';
import AirItemTypeService from '../services/AirItemTypeService';

function useAirItemTypeList() {
    const [airItemTypeList, setAirItemTypeList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchAirItemTypeList = async () => {
        setIsLoading(true);
        try {
            const response = await AirItemTypeService.getAirItemTypeList();
            console.log('Air Item Type List Response:', response);
            setAirItemTypeList(response.data.data || []);
            setError(null);
        } catch (err) {
            console.error('Error fetching air item type list:', err);
            setError(err);
            setAirItemTypeList([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAirItemTypeList();
    }, []);

    return {
        airItemTypeList,
        isLoading,
        error,
        refreshAirItemTypeList: fetchAirItemTypeList
    };
}

export default useAirItemTypeList;
